import { useState } from "react";
import classes from "./accordion.module.css";

interface AccordionProps {
  items: Array<AccordionItem>;
}

interface AccordionItem {
  title: string;
  content: any;
}

const Accordion = ({ items }: AccordionProps) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const AccordionItems = items.map((item, itemIndex) => {
    const classList = [classes.marketing__accordion_item];
    if (itemIndex == activeIndex)
      classList.push(classes.marketing__accordion_item_active);

    return (
      <div className={classList.join(" ")}>
        <div
          className={classes.marketing__accordion_item_title}
          onClick={() => setActiveIndex(itemIndex)}
        >
          {item.title}
          {itemIndex !== activeIndex && (
            <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37">
              <g transform="translate(-1461 -1141)">
                <circle
                  cx="18.5"
                  cy="18.5"
                  r="18.5"
                  fill="#00325a"
                  transform="translate(1461 1141)"
                />
                <path
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeWidth="4"
                  d="M1471 1160h18"
                />
                <path
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeWidth="4"
                  d="M1480 1151v18"
                />
              </g>
            </svg>
          )}
          {itemIndex == activeIndex && (
            <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37">
              <g transform="translate(-1461 -1287)">
                <circle
                  cx="18.5"
                  cy="18.5"
                  r="18.5"
                  fill="#00ab9d"
                  transform="translate(1461 1287)"
                />
                <path
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeWidth="4"
                  d="M1471 1306h17"
                />
              </g>
            </svg>
          )}
        </div>
        <div
          className={classes.marketing__accordion_item_content}
          dangerouslySetInnerHTML={{ __html: item.content }}
        ></div>
      </div>
    );
  });

  return <div className={classes.marketing__accordion}>{AccordionItems}</div>;
};

export { Accordion };
export type { AccordionItem };
